import CoreAPI from '../Core/CoreAPI';
import { PLATFORM_ID } from "../../Contants";
import { getSessionItem } from '@services/api/src/Domains/Enviroments/EnvironmentsService';

class TermsAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_TERMS')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_TERMS')));

    return this.api;
  }

  async getAcceptanceTerm (userID, descriptionTerm) {
    const descriptions = descriptionTerm ? `&description=${descriptionTerm}` : '';
    const url = `v1/Users/terms/unsigned?origin=${PLATFORM_ID}&externalId=${userID}${descriptions}`;
    const result = await this.getAPI().getInstance().get(url);
    return result;
  }

  async setAcceptanceTerm (term, userId, userName) {
    const data = {
      "origin": PLATFORM_ID,
      "externalId": userId,
      "Username": userName
    }

    const result = await this.getAPI().getInstance().post(`v1/terms/${term}/accept`, data);
    return result;
  }

   getTermDocument(nameTerm, version) {
    return  `${getSessionItem('API_TERMS_BFF')}term/${nameTerm}/version/${version}`;
  }
};

const api = new TermsAPI();
export default api;